
(function(){
  "use strict";

  /* ---------- motion ----------
     Motion is on everywhere, phones included. The only thing that turns it
     off is the visitor asking their own operating system for less of it.

     A 30 Aug 2026 change briefly folded "is a phone" into this flag. That was
     a misreading of the brief and is reverted; snippets/elio-still.liquid is
     inert and carries the note. If motion ever should come off below a
     breakpoint, this one line is the switch — every guard in this file reads
     it — but the reveal CSS in elio.css has to come off with it, or elements
     sit at their start state, which for .fade and .clip means invisible.

     iOS: Settings > Accessibility > Motion > Reduce Motion.
     Android: Settings > Accessibility > Remove animations.

     NOTE: this is a plain .js asset. Shopify does not render Liquid in it —
     only in a .js.liquid file — so a Liquid tag written here would be served
     literally and break the parse of the whole script. Keep it plain JS. */
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- stagger reveal for server-rendered cards ---------- */

  document.querySelectorAll(".pgrid, .rail").forEach(function(group){
    [].slice.call(group.children).forEach(function(el, i){
      el.style.setProperty("--d", (i % 4) * 85 + "ms");
    });
  });

  /* ---------- split text into masked lines / words ----------
     Lines are measured after layout so the mask breaks where the
     browser actually wraps, then re-measured on resize. */

  function splitEl(el){
    if (el.dataset.splitDone) return;
    var mode = el.dataset.split === "words" ? "words" : "lines";
    if (!el.dataset.raw) el.dataset.raw = el.innerHTML;

    if (mode === "words"){
      el.classList.add("split-w");
      el.innerHTML = el.dataset.raw.split(/\s+/).map(function(w, i){
        return '<span class="w" style="--d:' + (i*55) + 'ms"><i>' + w + "</i></span>";
      }).join(" ");
      el.dataset.splitDone = "1";
      return;
    }

    /* line mode: wrap each word, read its offsetTop, group into lines */
    var html = el.dataset.raw;
    var tmp = document.createElement("div");
    tmp.innerHTML = html;

    /* keep explicit <br> and inline chips as their own units */
    var units = [];
    (function walk(node){
      node.childNodes.forEach(function(n){
        if (n.nodeType === 3){
          n.textContent.split(/(\s+)/).forEach(function(t){
            if (t.trim()) units.push({ t:"w", html: t });
          });
        } else if (n.nodeName === "BR"){
          units.push({ t:"br" });
        } else {
          units.push({ t:"w", html: n.outerHTML });
        }
      });
    })(tmp);

    el.innerHTML = units.map(function(u, i){
      return u.t === "br" ? "<br>" : '<span data-w="' + i + '">' + u.html + "</span>";
    }).join(" ");

    var spans = [].slice.call(el.querySelectorAll("[data-w]"));
    var lines = [];
    var lastTop = null;
    spans.forEach(function(s){
      var top = s.offsetTop;
      if (lastTop === null || Math.abs(top - lastTop) > 2){ lines.push([]); lastTop = top; }
      lines[lines.length - 1].push(s);
    });

    el.innerHTML = lines.map(function(line, i){
      var inner = line.map(function(s){ return s.innerHTML; }).join(" ");
      return '<span class="msk"><i style="--d:' + (i * 110) + 'ms">' + inner + "</i></span>";
    }).join("");

    el.dataset.splitDone = "1";
  }

  var splits = [].slice.call(document.querySelectorAll('[data-anim="split"]'));
  function buildSplits(){
    splits.forEach(function(el){
      delete el.dataset.splitDone;
      splitEl(el);
    });
  }
  buildSplits();

  var rt;
  addEventListener("resize", function(){
    clearTimeout(rt);
    rt = setTimeout(function(){
      splits.forEach(function(el){
        if (!el.classList.contains("in")) return;   // only re-split what's settled
        delete el.dataset.splitDone;
        splitEl(el);
        el.classList.add("in");
      });
    }, 220);
  });

  /* ---------- reveal on scroll ----------
     Nothing is observed here. See the note at the foot of this file: doing it
     at this point is what made the site look like it had no animations. */

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target;
      var d = el.dataset.d;
      if (d) el.style.setProperty("--d", d + "ms");
      el.classList.add("in");
      io.unobserve(el);
    });
  }, { rootMargin: "0px 0px -12% 0px", threshold: 0.12 });

  function observeAll(){
    document.querySelectorAll('[data-anim]:not(.in)').forEach(function(el){ io.observe(el); });
  }

  /* ---------- scroll-linked drift (parallax) ----------
     Only elements that opt in with .drift move. Do NOT add .drift to a slot
     that is cover-fitted to a fixed frame: the translate lifts the image off
     the bottom of its .clip and exposes the page behind it. */

  var drifters = [].slice.call(document.querySelectorAll(".drift"));
  var ticking = false;
  function drift(){
    var vh = innerHeight;
    drifters.forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var progress = (r.top + r.height / 2 - vh / 2) / vh;   // -1 … 1
      var speed = parseFloat(el.dataset.speed || "0.08");
      el.style.translate = "0 " + (progress * speed * 100).toFixed(2) + "%";
    });
    ticking = false;
  }
  function onScroll(){
    if (!ticking && !reduce){ ticking = true; requestAnimationFrame(drift); }
  }
  addEventListener("scroll", onScroll, { passive: true });
  addEventListener("resize", onScroll);

  /* ---------- sticky header state ----------
     Every element looked up below is optional. The chrome snippets supply all
     of them on Elio-shell templates, but a template that omits the chrome must
     degrade rather than throw: an uncaught error here would abort the rest of
     this file, and the loader would never be dismissed. */

  var header = document.getElementById("header");
  if (header){
    addEventListener("scroll", function(){
      header.classList.toggle("is-stuck", scrollY > 40);
    }, { passive: true });
  }

  /* ---------- marquee: duplicate the track so the loop is seamless ---------- */

  var mq = document.getElementById("mq");
  if (mq) mq.innerHTML = mq.innerHTML + mq.innerHTML;

  /* ---------- rail arrows ---------- */

  document.querySelectorAll("[data-rail]").forEach(function(btn){
    btn.addEventListener("click", function(){
      var rail = document.getElementById("rail-" + btn.dataset.rail);
      if (!rail) return;
      var first = rail.firstElementChild;
      if (!first) return;
      var step = first.getBoundingClientRect().width + 20;
      rail.scrollBy({ left: step * parseInt(btn.dataset.dir, 10), behavior: "smooth" });
    });
  });

  /* ============================================================
     WISHLIST

     Storage is localStorage, an ordered array of product handles, newest
     first. That means it is per browser and needs no customer account, which
     is the right trade for a store with no login flow — but it also means a
     wishlist does not follow someone to another device. Moving to customer
     metafields later would keep this same interface: swap read/write and the
     rest of the module is unchanged.

     Product data is pulled from Shopify's own /products/{handle}.js endpoint
     when the drawer opens, so nothing about the product is duplicated into
     storage and a price or an image can never go stale. A handle that 404s
     (product deleted or unpublished) is dropped from the list rather than
     rendering a broken row.
     ============================================================ */

  (function(){
    var KEY = "elio:wishlist:v1";
    var cache = {};

    var drawer  = document.getElementById("wishlist");
    var listEl  = drawer && drawer.querySelector("[data-wish-list]");
    var CUR     = (drawer && drawer.getAttribute("data-currency")) || "CAD";

    function read(){
      try {
        var raw = localStorage.getItem(KEY);
        var list = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(list)) return [];
        return list.filter(function(h){ return typeof h === "string" && h; });
      } catch (e) { return []; }
    }

    function write(list){
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    function money(cents){
      try {
        return new Intl.NumberFormat(undefined, { style: "currency", currency: CUR }).format(cents / 100);
      } catch (e) {
        return "$" + (cents / 100).toFixed(2);
      }
    }

    function paintCounts(){
      var n = read().length;
      document.querySelectorAll("[data-wish-count]").forEach(function(el){
        el.textContent = String(n);
      });
    }

    /* Every heart on the page reflects storage, not its own last click. Two
       cards for the same product, or a second tab, therefore agree. */
    function paintHearts(){
      var list = read();
      document.querySelectorAll(".card__wish[data-handle]").forEach(function(b){
        var on = list.indexOf(b.getAttribute("data-handle")) !== -1;
        b.setAttribute("aria-pressed", String(on));
        b.textContent = on ? "♥" : "♡";
      });
    }

    function sync(){ paintCounts(); paintHearts(); }

    function fetchProduct(handle){
      if (cache[handle]) return Promise.resolve(cache[handle]);
      return fetch("/products/" + encodeURIComponent(handle) + ".js", {
        headers: { "Accept": "application/json" },
        credentials: "same-origin"
      }).then(function(r){
        if (!r.ok) throw new Error("missing");
        return r.json();
      }).then(function(p){ cache[handle] = p; return p; });
    }

    function firstAvailableVariant(p){
      for (var i = 0; i < (p.variants || []).length; i++){
        if (p.variants[i].available) return p.variants[i];
      }
      return null;
    }

    function row(p){
      var el = document.createElement("div");
      el.className = "wl__row";
      el.setAttribute("data-handle", p.handle);

      var thumb = document.createElement("a");
      thumb.className = "wl__thumb";
      thumb.href = p.url;
      if (p.featured_image){
        var img = document.createElement("img");
        img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, "_240x$1$2");
        img.alt = "";
        img.loading = "lazy";
        thumb.appendChild(img);
      }

      var info = document.createElement("div");
      info.className = "wl__info";

      var name = document.createElement("a");
      name.className = "wl__name";
      name.href = p.url;
      name.textContent = p.title;

      var price = document.createElement("span");
      price.className = "wl__price";
      price.textContent = money(p.price);

      var acts = document.createElement("div");
      acts.className = "wl__acts";

      var v = firstAvailableVariant(p);
      if (v){
        var add = document.createElement("button");
        add.type = "button";
        add.textContent = "Add to cart";
        add.addEventListener("click", function(){
          add.disabled = true;
          add.textContent = "Adding";
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          }).then(function(r){
            if (!r.ok) throw new Error("add failed");
            return fetch("/cart.js", { credentials: "same-origin" });
          }).then(function(r){ return r.json(); }).then(function(cart){
            document.querySelectorAll("[data-cart-count]").forEach(function(c){
              c.textContent = String(cart.item_count);
            });
            add.textContent = "In cart";
          }).catch(function(){
            add.disabled = false;
            add.textContent = "Try again";
          });
        });
        acts.appendChild(add);
      } else {
        /* Keeps .rm for the shared muted colour, adds .wl__out so "Sold out"
           and "Remove" are separately targetable — they were both bare .rm,
           which made button.rm ambiguous. */
        var out = document.createElement("span");
        out.className = "rm wl__out";
        out.textContent = "Sold out";
        acts.appendChild(out);
      }

      var rm = document.createElement("button");
      rm.type = "button";
      rm.className = "rm";
      rm.textContent = "Remove";
      rm.addEventListener("click", function(){
        var list = read();
        var i = list.indexOf(p.handle);
        if (i !== -1){ list.splice(i, 1); write(list); }
        sync();
        render();
      });
      acts.appendChild(rm);

      info.appendChild(name);
      info.appendChild(price);
      info.appendChild(acts);
      el.appendChild(thumb);
      el.appendChild(info);
      return el;
    }

    function empty(){
      var p = document.createElement("p");
      p.className = "wl__empty";
      p.textContent = "Nothing saved yet. Tap the heart on any product to keep it here — it stays in this browser, no account needed.";
      return p;
    }

    function render(){
      if (!listEl) return;
      var list = read();
      listEl.innerHTML = "";
      if (!list.length){ listEl.appendChild(empty()); return; }

      var loading = document.createElement("p");
      loading.className = "wl__empty";
      loading.textContent = "Loading…";
      listEl.appendChild(loading);

      Promise.all(list.map(function(h){
        return fetchProduct(h).catch(function(){ return null; });
      })).then(function(products){
        /* Drop anything that no longer resolves, so a deleted product cleans
           itself out of storage instead of failing forever. */
        var kept = [];
        products.forEach(function(p, i){ if (p) kept.push(list[i]); });
        if (kept.length !== list.length){ write(kept); paintCounts(); }

        listEl.innerHTML = "";
        var any = false;
        products.forEach(function(p){
          if (!p) return;
          any = true;
          listEl.appendChild(row(p));
        });
        if (!any) listEl.appendChild(empty());
      });
    }

    /* ---- open / close ---- */

    var lastTrigger = null;

    function open(){
      if (!drawer) return;
      render();
      drawer.classList.add("is-open");
      document.body.classList.add("wl-lock");
      requestAnimationFrame(function(){ drawer.classList.add("is-in"); });
      /* .wl__x, not [data-wish-close] — the scrim carries that attribute too
         and comes first in the DOM, and focusing a div with no tabindex is a
         silent no-op that leaves focus outside the dialog. */
      var x = drawer.querySelector(".wl__x");
      if (x && x.focus) x.focus();
    }

    function close(){
      if (!drawer) return;
      drawer.classList.remove("is-in");
      document.body.classList.remove("wl-lock");
      setTimeout(function(){ drawer.classList.remove("is-open"); }, reduce ? 0 : 480);
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
      lastTrigger = null;
    }

    /* ---- one delegated listener covers cards rendered at any time ---- */

    document.addEventListener("click", function(e){
      var heart = e.target.closest(".card__wish");
      if (heart){
        var handle = heart.getAttribute("data-handle");
        if (!handle) return;                 // nothing to save against
        var list = read();
        var i = list.indexOf(handle);
        if (i === -1) list.unshift(handle); else list.splice(i, 1);
        write(list);
        sync();
        if (drawer && drawer.classList.contains("is-open")) render();
        return;
      }
      var trigger = e.target.closest("[data-wish-open]");
      if (trigger){ e.preventDefault(); lastTrigger = trigger; open(); return; }
      if (e.target.closest("[data-wish-close]")){ close(); }
    });

    document.addEventListener("keydown", function(e){
      if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) close();
    });

    /* A second tab writing the same key repaints this one. */
    addEventListener("storage", function(e){
      if (e.key !== KEY) return;
      sync();
      if (drawer && drawer.classList.contains("is-open")) render();
    });

    sync();
  })();

  /* ---------- cursor image trail in the quote band ----------
     Dormant since 30 Aug 2026: the quote band no longer renders #trail or
     #qcursor, so this returns early. Put those two divs back to restore it. */

  (function(){
    if (reduce) return;
    var zone   = document.getElementById("quote");
    var trail  = document.getElementById("trail");
    var cursor = document.getElementById("qcursor");
    if (!zone || !trail || !cursor) return;

    var FILE_BASE = "https://cdn.shopify.com/s/files/1/0775/7748/6530/files/";
    var SLOTS = ["Trail 01","Trail 02","Trail 03","Trail 04","Trail 05"];
    var pool = SLOTS.map(function(label, i){
      var d = document.createElement("div");
      d.className = "trail__img";
      d.textContent = label;
      var img = new Image();
      img.alt = "";
      img.loading = "lazy";
      img.onerror = function(){ img.remove(); };
      img.src = FILE_BASE + "elio-trail-0" + (i + 1) + ".jpg";
      d.appendChild(img);
      trail.appendChild(d);
      return d;
    });

    var idx = 0, lastX = 0, lastY = 0, primed = false;

    zone.addEventListener("pointerenter", function(){ cursor.style.opacity = "1"; });
    zone.addEventListener("pointerleave", function(){ cursor.style.opacity = "0"; });

    zone.addEventListener("pointermove", function(ev){
      if (ev.pointerType !== "mouse") return;
      var r = zone.getBoundingClientRect();
      var x = ev.clientX - r.left;
      var y = ev.clientY - r.top;

      cursor.style.left = x + "px";
      cursor.style.top  = y + "px";

      if (!primed){ lastX = x; lastY = y; primed = true; return; }

      var dist = Math.hypot(x - lastX, y - lastY);
      if (dist < 190) return;
      lastX = x; lastY = y;

      var el = pool[idx % pool.length];
      idx++;

      el.style.transition = "none";
      el.style.left = x + "px";
      el.style.top  = y + "px";
      el.style.opacity = "1";
      el.style.transform = "translate(-50%,-50%) scale(1)";

      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          el.style.transition = "opacity 1.1s var(--ease), transform 1.1s var(--ease)";
          el.style.opacity = "0";
          el.style.transform = "translate(-50%,-50%) scale(.82)";
        });
      });
    });
  })();

  /* ---------- footer year ---------- */
  var yr = document.getElementById("yr");
  if (yr) yr.textContent = new Date().getFullYear();

  /* ============================================================
     LIFT THE LOADER, THEN REVEAL

     THE BUG THIS FIXES, found 30 Aug 2026. observeAll() used to run near the
     top of this file, the moment the script executed. The IntersectionObserver
     fired immediately for everything already on screen, so the whole first
     screenful ran its 0.8–1.5s reveal BEHIND the loader — an opaque overlay at
     z-index 200 — and had finished long before the overlay faded. The site
     looked like it had no animations at all, on every device; a phone made it
     worse, because one screenful is most of what you see before you scroll.

     So nothing is observed until the loader is on its way out. Below-the-fold
     content is unaffected either way: it reveals as you reach it.

     THE HOLD IS TIMED FROM HERE, not from window load. This file is deferred,
     so it runs once the document is parsed — which means a hero video or a
     slow image can no longer hold the overlay up for as long as it likes.
     1150ms matches the loading bar's own animation, so the bar completes just
     as the overlay goes.

     When the intro is suppressed — a repeat visitor, or a collection filter
     click; see snippets/elio-chrome-header.liquid — there is nothing to wait
     for and the reveals start straight away.
     ============================================================ */

  var loader = document.getElementById("loader");
  var suppressed = document.documentElement.classList.contains("elio-no-loader");

  function start(){
    if (loader) loader.classList.add("done");
    observeAll();
    onScroll();
  }

  if (reduce){
    if (loader) loader.classList.add("done");
    document.querySelectorAll("[data-anim]").forEach(function(el){ el.classList.add("in"); });
  } else {
    setTimeout(start, suppressed ? 60 : 1150);
  }
})();
